interface LoadingScreenProps {
  message?: string
}

export function LoadingScreen({ message = 'Carregando…' }: LoadingScreenProps) {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <span className="loading-screen__spinner" aria-hidden="true" />
      <span>{message}</span>
    </div>
  )
}
